module.exports = {
  apiHost: "https://api.covella.sensoreal.com.au",
  assetsHost: "https://assets.covella.sensoreal.com.au",
  langs: [{ code: "en", dir: "ltr" }],
  formTemplate: "Covella",
  style: {
    primaryColor: "#141937",
    textColor: "#fff",
  },
  header: {
    logo: "",
    text: {
      en: "Your Covella Selections",
    },
    color: "#fff",
  },
  footerLogo:
    "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/avid-edm/general/AVID_Greenfields_Logos_v2.png",
  links: {
    instagram: "https://www.instagram.com/avid_together/",
    facebook: "https://www.facebook.com/CovellaGreenbank/",
    linkedin: "https://au.linkedin.com/company/avid-property-group",
    privacy: "",
    twitter: "",
    youtube: "https://www.youtube.com/channel/UCEnh4QABTOnsovDd-Hg45OQ",
  },
  contact: {
    address: "82 Pub Lane, Greenbank QLD 4124",
    email: "covella@avid.com.au",
    phone: "1800 987 257",
    website: "https://covella.avid.com.au",
  },
};
